var exports = {
  "y": "x234b8571--031f8a--pin",
  "b": "x234b8571--031f8a--pin--image",
};

module.exports = exports;
